import { render } from "./VoucherSavingSuggestions.vue?vue&type=template&id=8107bda6&scoped=true"
import script from "./VoucherSavingSuggestions.vue?vue&type=script&lang=js"
export * from "./VoucherSavingSuggestions.vue?vue&type=script&lang=js"

import "./VoucherSavingSuggestions.vue?vue&type=style&index=0&id=8107bda6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8107bda6"]])

export default __exports__